import { buildURL, buildObjectFromURL } from './url';

function findParentCategories(categories = {}, categoryId) {
    const tree = [];

    if (!categoryId) {
        return tree;
    }

    tree.push(Object.assign({}, categories[categoryId]));

    let parent = Object.values(categories).find(category => {
        if (category.sub_categories) {
            if (category.sub_categories.includes(categoryId)) {
                return category.sub_categories.includes(categoryId);
            }

            const parentCategory = category.sub_categories.find(category => {
                return category.id === categoryId;
            });

            if (parentCategory) {
                return parentCategory;
            }

            return false;
        }

        return false;
    });

    while (parent) {
        tree.push(Object.assign({}, parent));
        parent = Object.values(categories).find(category => {
            if (category.sub_categories) {
                return category.sub_categories.includes(parent.id);
            }

            return false;
        });
    }

    return tree;
}

function getCategoryHeirarchy(flatCategoryMap, categoryId, location, config = { get: () => { } }, sessionFeatures, mode) {
    const heirarchy = [];
    const useFakeLevelSlug = config.get('SEO', 'useFakeLevelSlug');
    const categoryCover = config.get('categoryCover');
    const seoFriendlyBreadcrumb = config.get('seoFriendlyBreadcrumb');
    const noindexListingCategories = config.get('SEO', 'noindexListingCategories');
    const isSellPage = mode === 'sell';

    while (categoryId) {
        const category = flatCategoryMap[categoryId];
        const isNoIndexCategory = noindexListingCategories
            && noindexListingCategories.length > 0
            && noindexListingCategories.indexOf(categoryId) >= 0;

        if (!category || isNoIndexCategory || (isSellPage && category.parent_id === 0)) {
            break;
        }

        const text = (seoFriendlyBreadcrumb && category.parent_id) ? {
            translation: {
                id: 'usedCategory',
                values: {
                    category: category.name
                }
            }
        } : {
            text: isSellPage ? `Sell ${category?.name}` : category.name
        };

        heirarchy.unshift({
            ...text,
            href: buildURL({
                category,
                location,
                base: isSellPage ? 'sell' : ''
            }, { useFakeLevelSlug, categoryCover })
        });

        categoryId = !(seoFriendlyBreadcrumb && seoFriendlyBreadcrumb.hideCategoryL1) && category.parent_id;
    }

    return heirarchy;
}

const getIsCategoryDeprecated = (categoryId, deprecatedCategoryIds = []) => !!(categoryId && Array.isArray(deprecatedCategoryIds) && deprecatedCategoryIds.some(dc => Number(dc) === Number(categoryId)));

const getUrlObj = pathname => buildObjectFromURL(pathname);

const getCategoryTagText = (categoriesTag, categoryId, currentLocale) => {
    const categoryTagTextObj = categoriesTag[categoryId];
    const enKey = Object.keys(categoryTagTextObj)[0];
    const hiKey = Object.keys(categoryTagTextObj)[1];
    let categoryTagText = categoryTagTextObj[enKey];

    // TODO: Add check of new common getPathParam func for client translation
    if (currentLocale === hiKey.toLocaleLowerCase()) {
        categoryTagText = categoryTagTextObj[hiKey];
    }

    return categoryTagText ? categoryTagText.name : null;
};

const classifyCategoryByOrder = values => {
    const popular = [];
    const others = [];

    values.forEach(val => {
        if (val.popular_order > 0) {
            popular.push(val);
        }
        others.push(val);
    });

    return { popular, others };
};

const sortCategoriesByOrder = (options, orderKey) => {
    return [...options].sort((a, b) => a[orderKey] - b[orderKey]);
};

export {
    getCategoryHeirarchy,
    getIsCategoryDeprecated,
    findParentCategories,
    getUrlObj,
    getCategoryTagText,
    classifyCategoryByOrder,
    sortCategoriesByOrder
};
